import React from 'react';
import { SizableText, XStack, YStack } from 'tamagui';

export interface EmptyStateViewProps {
  title: string;
  description?: string;
  /** Optional visual element (icon, illustration, emoji) displayed above the title. */
  icon?: React.ReactNode;
  /** Optional action area (button, link, etc.) rendered below the description. */
  action?: React.ReactNode;
}

export const EmptyStateView = ({
  title,
  description,
  icon,
  action,
}: EmptyStateViewProps): React.ReactElement => (
  <YStack
    flex={1}
    alignItems="center"
    justifyContent="center"
    gap="$true"
    padding="$true"
    width="100%"
  >
    {icon && <XStack>{icon}</XStack>}
    <SizableText size="$h6" fontFamily="$bold" textAlign="center">
      {title}
    </SizableText>
    {description && (
      <SizableText size="$2" color="$secondary50" textAlign="center">
        {description}
      </SizableText>
    )}
    {action && <XStack>{action}</XStack>}
  </YStack>
);
